class FAQSectionManager {
  constructor() {
    this.tabButtons = document.querySelectorAll('[data-faq-tab]');
    this.contentPanels = document.querySelectorAll('[data-faq-panel]');
    this.accordionTriggers = document.querySelectorAll('[data-faq-trigger]');

    this.activeTabClass = 'allter-faq-tabs-container__button--active';
    this.activePanelClass = 'allter-faq-content-panel--active';
    this.activeHeaderClass = 'allter-faq-accordion-item__header--active';
    this.activeContentClass = 'allter-faq-accordion-item__content--active';

    this.init();
  }

  init() {
    this.attachTabListeners();
    this.attachAccordionListeners();
  }

  attachTabListeners() {
    this.tabButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        this.handleTabClick(e, button);
      });
    });
  }

  attachAccordionListeners() {
    this.accordionTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        this.handleAccordionClick(e, trigger);
      });
    });
  }

  handleTabClick(event, button) {
    event.preventDefault();

    const tabName = button.getAttribute('data-faq-tab');

    this.deactivateAllTabs();
    this.activateTab(button, tabName);
  }

  deactivateAllTabs() {
    this.tabButtons.forEach((button) => {
      button.classList.remove(this.activeTabClass);
      button.setAttribute('aria-selected', 'false');
    });

    this.contentPanels.forEach((panel) => {
      panel.classList.remove(this.activePanelClass);
    });
  }

  activateTab(button, tabName) {
    button.classList.add(this.activeTabClass);
    button.setAttribute('aria-selected', 'true');

    const panel = document.querySelector(
      `[data-faq-panel="${tabName}"]`
    );

    if (panel) {
      panel.classList.add(this.activePanelClass);
    }
  }

  handleAccordionClick(event, trigger) {
    event.preventDefault();

    const isActive = trigger.classList.contains(this.activeHeaderClass);
    const contentElement = trigger.nextElementSibling;

    if (isActive) {
      this.collapseAccordion(trigger, contentElement);
    } else {
      this.expandAccordion(trigger, contentElement);
    }
  }

  expandAccordion(header, content) {
    header.classList.add(this.activeHeaderClass);
    header.setAttribute('aria-expanded', 'true');
    content.classList.add(this.activeContentClass);
  }

  collapseAccordion(header, content) {
    header.classList.remove(this.activeHeaderClass);
    header.setAttribute('aria-expanded', 'false');
    content.classList.remove(this.activeContentClass);
  }
}

function revealTestimonialSlider() {
  let sliders = document.querySelectorAll('.sm-slider .reveal-testimonials');

  if(!sliders.length || window.matchMedia('(min-width: 769px)').matches) return;

  sliders.forEach(slider => {
    new Flickity(slider, {
      wrapAround: true,
      contains: true,
      cellAlign: 'left',
      prevNextButtons: false,
      pageDots: true
    });
  });
}

function benifitSlider() {
  let slider = document.querySelector('.benefits-cards.slider');

  if(!slider || window.matchMedia('(min-width: 1024px)').matches) return;

  new Flickity(slider, {
    wrapAround: true,
    contains: true,
    cellAlign: 'left',
    prevNextButtons: false,
    pageDots: true
  });
}

function benefitBannerSlider () {
  let slider = document.querySelector('.benefit-point__details .benefits');

  if(!slider || window.matchMedia('(min-width: 1024px)').matches) return;

  new Flickity(slider, {
    wrapAround: true,
    contains: true,
    cellAlign: 'left',
    prevNextButtons: false,
    pageDots: true
  });
}


function metaMulticolumnSlider () {
  let slider = document.querySelector('.meta-multicolumn');

  if(!slider || window.matchMedia('(min-width: 768px)').matches) return;

  new Flickity(slider, {
    wrapAround: true,
    contains: true,
    cellAlign: 'left',
    prevNextButtons: false,
    pageDots: true
  });
}

function initProductInfoTabs() {
  const productInfo = document.querySelector('.product-info');
  if (!productInfo) return;

  const tabButtons = productInfo.querySelectorAll('.tabs button');
  const tabContents = productInfo.querySelectorAll('.tab-content');

  function activateTab(tabId, clickedButton) {
    tabButtons.forEach(btn => btn.classList.remove('active'));
    tabContents.forEach(content => content.classList.remove('is-selected'));

    clickedButton.classList.add('active');
    productInfo.querySelector(`#${tabId}`)?.classList.add('is-selected');
  }

  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      const tabId = button.getAttribute('data-id');
      activateTab(tabId, button);
    });
  });

  if (tabButtons.length) {
    activateTab(tabButtons[0].dataset.id, tabButtons[0]);
  }
}

function benefit_banner() {
  const points = document.querySelectorAll('.benefit__points .point');
  const benefitItems = document.querySelectorAll('.benefit__item');

  if (!points.length || !benefitItems.length) return;

  points.forEach((point, index) => {
    point.addEventListener('click', () => {
      if (!benefitItems[index]) return;

      points.forEach(p => p.classList.remove('active'));
      benefitItems.forEach(item => item.classList.remove('is-selected'));

      point.classList.add('active');
      benefitItems[index].classList.add('is-selected');
    });
  });
}

function copyOffer() {
  let btns = document.querySelectorAll(".copy-offer");
  if(!btns.length) return;

  btns.forEach(btn => {
      btn.addEventListener("click", function () {
      const code = this.getAttribute("data-code");

      navigator.clipboard.writeText(code).then(() => {
        const originalText = this.textContent;
        this.textContent = "Copied";

        setTimeout(() => {
          this.textContent = originalText;
        }, 2000);
      });
    });
  });

}


document.addEventListener('DOMContentLoaded', function() {
  metaMulticolumnSlider();
  initProductInfoTabs();
  benifitSlider();
  revealTestimonialSlider();
  benefit_banner();
  benefitBannerSlider();
  new FAQSectionManager();
  copyOffer();
});